'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// TODO: Remove this when we have a better solution
// For now it's the only way to make sure that the file is not empty
// when generated as CJS, so we can import partial files from mobile app
var _unused = {};

exports._unused = _unused;
